import { render, staticRenderFns } from "./CorrectData.vue?vue&type=template&id=43330c6e&scoped=true"
import script from "./CorrectData.vue?vue&type=script&lang=js"
export * from "./CorrectData.vue?vue&type=script&lang=js"
import style0 from "./CorrectData.vue?vue&type=style&index=0&id=43330c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43330c6e",
  null
  
)

export default component.exports